"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelephoneNumberInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const react_1 = require("react");
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const InputWrapper = (0, react_1.forwardRef)(({ component: Component, id, required, ...props }, ref) => ( /* eslint-disable-line @typescript-eslint/no-explicit-any*/(0, jsx_runtime_1.jsx)(Component, { enableSearch: true, disableSearchIcon: true, ...props, inputProps: {
        ref,
        id,
        required,
        autoComplete: props.autoComplete,
    } })));
const TelephoneNumberInputRoot = (0, styles_1.styled)(TextField_1.default)(({ theme }) => (0, styles_1.css) `
	position: relative;

	.selected-flag, .flag-dropdown {
		border: none !important;
		background-color: transparent !important;
	}

	&.medium {
		.react-tel-input, .form-control {
			height: 56px !important;
		}
		.react-tel-input {
			padding: 0;
		}
	}

	.react-tel-input {
		padding: ${theme.spacing(1)};
		height: 100%;
		input.form-control, input.search-box {
			width: 100%;
			max-width: 100%;
			padding-inline-start: ${theme.spacing(5)};
			height: 100%;
			border: 0;
			font-family: inherit;
			font-weight: 400;
			font-size: 19.2px;

			&:disabled {
				cursor: default !important;
			}
		}
	}

	&.adorned .react-tel-input {
		padding-inline-start: 0;
	}
`);
/** Strip leading `'+'` before passing to the `<input>`. */
const getInputValue = (value) => {
    if (value === undefined) {
        return undefined;
    }
    if (value.startsWith('+')) {
        return value.slice(1);
    }
    return value;
};
/** Add leading `'+'` before dispatching the change event. */
const getEventValue = (value) => {
    if (value.length && !value.startsWith('+')) {
        return '+' + value;
    }
    return value;
};
/**
 * Formatted telephone number input.
 *
 * You will need to include the CSS file, eg:
 *
 * ```ts
 * import { TelephoneNumberInput } from '@charterindex/armoury-www';
 * import '@charterindex/armoury-www/telephone-number-input.css';
 * ```
 *
 * Wrapper around [react-phone-input-2](https://www.npmjs.com/package/react-phone-input-2)
 * with MUI styling.
 */
exports.TelephoneNumberInput = (0, react_1.forwardRef)((p, ref) => {
    const handleChange = (value, details, event) => {
        p.onChange?.({
            value: getEventValue(value),
            details,
            event,
            target: event.target,
        });
    };
    let fullClassName = p.className ?? '';
    if (p.startAdornment) {
        fullClassName += ' adorned';
    }
    if (p.size === 'medium') {
        fullClassName += ' medium';
    }
    return ((0, jsx_runtime_1.jsx)(TelephoneNumberInputRoot, { id: p.id, className: fullClassName, value: getInputValue(p.value), label: p.label, error: p.error, helperText: p.helperText, disabled: p.disabled, required: p.required, InputProps: {
            inputComponent: InputWrapper,
            startAdornment: p.startAdornment,
            inputProps: {
                ref,
                autoComplete: p.autoComplete ? 'tel' : undefined,
                component: react_phone_input_2_1.default,
                country: p.defaultCountryCode,
                required: p.required,
                enableClickOutside: !p.disableClickOutsideToFixShadowDomBehaviour,
                // `<PhoneInput>` has a non-standard onChange callback signature.
                onChange: handleChange, // eslint-disable-line @typescript-eslint/no-explicit-any
            },
        }, onFocus: p.onFocus, onBlur: p.onBlur, InputLabelProps: {
            // Always shrink the label, as the `<input>` will have placeholder text.
            shrink: true,
        } }));
});
//# sourceMappingURL=telephone-number-input.js.map